exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "b{font-size: 18px; padding:15px 0 0; display: block;}\nh2{border-bottom: 1px solid #cccccc;}\n.mat-dialog-title{padding-bottom: 5px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/delete-attendee-warning/delete-attendee-warning.component.css
// module id = ../../../../../src/app/delete-attendee-warning/delete-attendee-warning.component.css
// module chunks = 39